import { PasswordresetComponent } from './auth_handlers_page/passwordreset.component';
import { SoporteComponent } from './soporte/soporte.component';
import { OlvidarpassComponent } from './olvidarpass/olvidarpass.component';
import { RegistroComponent } from './registro/registro.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { LoginComponent } from './login/login.component';
import { AdminModule } from './admin/admin.module';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from './services/authentication.guard';
import { RegistroAcademicaComponent } from './registro-academica/registro-academica.component';
import { RedirectComponent } from './redirect/redirect.component';
import { NecesitoayudaComponent } from './necesitoayuda/necesitoayuda.component';
import { SupportComponent } from './support/support.component';
import { NopuedoconectarmeComponent } from './nopuedoconectarme/nopuedoconectarme.component';
import { PersonalizacionComponent } from './personalizacion/personalizacion.component';
import { CustomizationComponent } from './customization/customization.component';
import { Test123Component } from './test123/test123.component';
import { ColegiaComponent } from './colegia/colegia.component';
import { AcademicaredirectComponent } from './academicaredirect/academicaredirect.component';
import { MyfregisterComponent } from './myfregister/myfregister.component';
import { LleexregisterComponent } from './lleexregister/lleexregister.component';
import { HelpdeskComponent } from './helpdesk/helpdesk.component';
import { ConnectingfromschoolComponent } from './connectingfromschool/connectingfromschool.component';
import { BullyinglistComponent } from './bullyinglist/bullyinglist.component';
import { ManualComponent } from './manual/manual.component';
import { ManualColegiaComponent } from './manual-colegia/manual-colegia.component';
import { ManualColegiaProfesorComponent } from './manual-colegia-profesor/manual-colegia-profesor.component';
import { PostersComponent } from './posters/posters.component';
import { LiveComponent } from './live/live.component';
import { LiveMyfComponent } from './live-myf/live-myf.component';
import { LiveUniversityComponent } from './live-university/live-university.component';
import { LiveusaComponent } from './liveusa/liveusa.component';
import { ExternoModule } from './externo/externo.module';
import { EliminarcuentaComponent } from './eliminarcuenta/eliminarcuenta.component';
import { PoliticaComponent } from './politica/politica.component';
import { PadresModule } from './padres/padres.module';
import { MagisnetComponent } from './magisnet/magisnet.component';
import { LoginMoodleComponent } from './login-moodle/login-moodle.component';


const routes: Routes = [
  {
    path: 'myfregister23',
    component: MyfregisterComponent,
  },
  {
    path: 'lleexregister23',
    component: LleexregisterComponent,
  },
  {
    path: '',
    component: ColegiaComponent,
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'profesores',
    component: LoginComponent,
  },
  {
    path: 'colegia',
    component: ColegiaComponent,
  },
  {
    path: 'moodle',
    component: LoginMoodleComponent,
  },
  {
    path: 'thecampus',
    component: ColegiaComponent,
  },
  {
    path: 'admin',
    loadChildren: () => AdminModule,
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'external',
    loadChildren: () => ExternoModule,
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'padres',
    loadChildren: () => PadresModule,
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () => DashboardModule,
    canActivate: [AuthenticationGuard],
    data: {
      rol: 'admin',
    },
  },
  {
    path: 'registro',
    component: RegistroComponent,
  },
  {
    path: 'registroAcademica',
    component: RegistroAcademicaComponent,
  },
  {
    path: 'olvidar',
    component: OlvidarpassComponent,
  },
  // {
  //   path: 'soporte', component: SoporteComponent
  // },
  {
    path: 'necesito-ayuda',
    component: NecesitoayudaComponent,
  },
  {
    path: 'help-desk',
    component: HelpdeskComponent,
  },
  {
    path: 'support',
    component: SupportComponent,
  },
  {
    path: 'ayuda_para_conectarme_desde_el_cole',
    component: NopuedoconectarmeComponent,
  },
  {
    path: 'connecting_from_school',
    component: ConnectingfromschoolComponent,
  },
  {
    path: 'personalizacion',
    component: PersonalizacionComponent,
  },
  {
    path: 'magisnet',
    component: MagisnetComponent,
  },
  {
    path: 'ksp',
    loadChildren: () => import('./ksp/ksp.module').then(m => m.KspModule),
  },
  {
    path: 'customization',
    component: CustomizationComponent,
  },
  {
    path: 'auth',
    component: PasswordresetComponent,
  },
  {
    path: 'video/:nombre',
    component: AcademicaredirectComponent,
  },
  {
    path: 'bullying/list/add',
    component: BullyinglistComponent,
  },
  {
    path: 'manualUsuario',
    component: ManualComponent,
  },
  {
    path: 'manualColegia',
    component: ManualColegiaComponent,
  },
  {
    path: 'manualColegia/profesor',
    component: ManualColegiaProfesorComponent,
  },
  {
    path: 'eliminar',
    component: EliminarcuentaComponent,
  },
  {
    path: 'politica',
    component: PoliticaComponent,
  },
  {
    path: 'posters/academica/:carpeta',
    component: PostersComponent,
  },
  {
    path: 'live/:url',
    component: LiveComponent,
  },
  {
    path: 'myf/live/:url',
    component: LiveMyfComponent,
  },
  {
    path: 'university/live/:url',
    component: LiveUniversityComponent,
  },
  {
    path: 'usa/live/:url',
    component: LiveusaComponent,
  },
  // {
  //   path: 'test123',
  //   component: Test123Component,
  // },
  { path: ':sala', component: RedirectComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
